import service from '@api/config'

// 根据项目id获取项目详情
export const getProjectInfo = (data) => {
  return service.request({
    url: `/bid/getProjectInfo`,
    method: 'post',
    data: data
  })
}

// 根据项目id获取投标队伍列表
export const getTenderCompany = (data) => {
  return service.request({
    url: `/bid/getTenderCompany`,
    method: 'post',
    data: data
  })
}

// 项目投标
export const tender = (data) => {
  return service.request({
    url: `/bid/tender`,
    method: 'post',
    data: data
  })
}

// 查询当前队伍信息
export const getMyCompany = (data) => {
  return service.request({
    url: `/bid/getMyCompany`,
    method: 'post',
    data: data
  })
}

// 拒绝接标
export const refuse = (data) => {
  return service.request({
    url: `/bid/refuse`,
    method: 'post',
    data: data
  })
}

// 接标
export const accept = (data) => {
  return service.request({
    url: `/bid/accept`,
    method: 'post',
    data: data
  })
}

// 项目报名
export const signIn = (data) => {
  return service.request({
    url: `/bid/signIn`,
    method: 'post',
    data: data
  })
}

//根据项目id获取项目详情及报名投标状态
export const getProjectTender = (data) => {
  return service.request({
    url: `/bid/getProjectTender`,
    method: 'post',
    data: data
  })
}

// 根据项目id获取已结束项目中标队伍列表
export const getTenderResult = (data) => {
  return service.request({
    url: `/bid/getTenderResult`,
    method: 'post',
    data: data
  })
}

// 根据项目id获取候选人队伍列表及公布结果
export const getWinCompany = (data) => {
  return service.request({
    url: `/bid/getWinCompany`,
    method: 'post',
    data: data
  })
}

// 根据投标id查询队伍投标信息
export const getCompanyTender = (data) => {
  return service.request({
    url: `/bid/getCompanyTenderInfo`,
    method: 'post',
    data: data
  })
}
